export default "__VITE_ASSET__BwUEQ42___"